import { useTheme } from '../context/ThemeContext';

// Theme-aware chrome colors for Recharts (which needs real values, not classes).
// Series colors (CHART_COLORS) stay the same; only axes/grid/tooltip adapt.
export function useChartTheme() {
  const dark = useTheme()?.dark;
  if (dark) {
    return {
      tick: '#94a3b8',
      grid: '#1e293b',
      axis: '#334155',
      cursor: 'rgba(148, 163, 184, 0.14)',
      tooltip: {
        borderRadius: 10,
        backgroundColor: '#0f172a',
        border: '1px solid #334155',
        color: '#e2e8f0',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.45)',
        fontSize: 12,
        padding: '8px 12px',
      },
    };
  }
  return {
    tick: '#64748b',
    grid: '#eef2f7',
    axis: '#e2e8f0',
    cursor: 'rgba(37, 99, 235, 0.06)',
    tooltip: {
      borderRadius: 10,
      backgroundColor: '#ffffff',
      border: '1px solid #e2e8f0',
      color: '#0f172a',
      boxShadow: '0 6px 20px rgba(15, 23, 42, 0.08)',
      fontSize: 12,
      padding: '8px 12px',
    },
  };
}
